import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { type PartialDeep } from 'type-fest';

import { type CanvasElementFrom } from '@blaze-runtime/engine-domain';

import { type DefinitionMapper } from '../../../ai';
import { NumberType } from '../../../ai/models/chart';

import { type BaseRoundChartDefinition, type RoundChartType } from './round-chart.definition';

abstract class RoundChartDefinitionMapper<T extends RoundChartType> implements DefinitionMapper<T> {
  protected readonly store = inject(Store);

  abstract readonly type: T;

  extract(element: CanvasElementFrom<T>): PartialDeep<BaseRoundChartDefinition<T>> {
    const content = element.props.content;

    return {
      title: content.title?.label,
      showTitle: content.title?.enabled,
      yAxisFormat: this.getAxisFormat(element),
    };
  }

  protected getAxisFormat(element: CanvasElementFrom<T>): NumberType | undefined {
    switch (element.props.content.format?.type) {
      case 'Currency':
        return NumberType.Currency;
      case 'Percent':
        return NumberType.Percent;
      case 'Number':
        return NumberType.Number;
      default:
        return undefined;
    }
  }
}

export class DoughnutChartDefinitionMapper extends RoundChartDefinitionMapper<'chartDoughnut'> {
  readonly type = 'chartDoughnut';
}

export class PieChartDefinitionMapper extends RoundChartDefinitionMapper<'chartPie'> {
  readonly type = 'chartPie';
}
